// extracted by mini-css-extract-plugin
module.exports = {"root":"IconHeart_root__3-Xtd"};